import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "MessengerColor.svg",
  "use": "MessengerColor.svg-usage",
  "viewBox": "0 0 37 36",
  "content": "<symbol viewBox=\"0 0 37 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"MessengerColor.svg\">\n<path d=\"M18.681 0C8.87276 0 0.92041 7.46104 0.92041 16.6665C0.92041 21.9135 3.50159 26.5875 7.53473 29.6475V36L13.5852 32.637C15.2014 33.087 16.9094 33.333 18.681 33.333C28.4893 33.333 36.4417 25.8705 36.4417 16.668C36.4417 7.46552 28.4893 0 18.681 0ZM20.4438 22.4445L15.9223 17.5545L7.09669 22.4445L16.8043 12L21.4384 16.8885L30.1544 12L20.4438 22.4445Z\" fill=\"#2775EA\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol